import { render } from "./login-access.vue?vue&type=template&id=6acbc932&scoped=true"
import script from "./login-access.vue?vue&type=script&lang=js"
export * from "./login-access.vue?vue&type=script&lang=js"

import "./login-access.vue?vue&type=style&index=0&id=6acbc932&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6acbc932"]])

export default __exports__